/*
 * Copyright 2023 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { OrderViewButtonPage } from '../components/page/OrderViewButtonPage'
import { Extensible } from '../components/extensible/Extensible'
import { UixContainer } from '../components/page/UixContainer'

export const displayOrderViewButtons = (
  config,
  selectedExtension,
  imsToken
) => {
  const sharedContext = {
    imsToken: imsToken
  }

  const contentElement = ReactDOM.createRoot(
    document.getElementById('uix-order-view-button')
  )

  contentElement.render(
    <React.StrictMode>
      <UixContainer>
        <Extensible
          extensions={selectedExtension}
          sharedContext={sharedContext}
        >
          <OrderViewButtonPage
            buttonId={config.orderViewButton.buttonId}
            extensionId={Object.keys(selectedExtension)[0] ?? ''}
            orderId={config.orderViewButton.orderId}
            redirectUrl={config.orderViewButton.redirectUrl}
          />
        </Extensible>
      </UixContainer>
    </React.StrictMode>
  )
}
